import React, { RefObject, forwardRef, useCallback, useEffect, useRef } from "react";
import { HeaderModal } from "../headerModal";
import { PushNotification } from "./PushNotification";
import { PushStore } from "../../store/pushStore";
import { PageRoutes, useStore, useViewModel } from "../../utils";
import { observer } from "mobx-react-lite";
import { MeetingViewModel } from "../calendar";
import '../../styles/components/pushModal.scss';
import { useNavigate } from "react-router-dom";
import { MeetingPlanerViewModel } from "../../views";

interface PushModalProps {
  onClose: () => void;
  visible: boolean;
}

export const PushModal = observer(forwardRef<HTMLDivElement, PushModalProps>((
  { visible, onClose }, ref: RefObject<HTMLDivElement>
) => {
  const meetingViewModel = useViewModel(MeetingViewModel);
  const meetingPlanerViewModel = useViewModel(MeetingPlanerViewModel);
  const pushStore = useStore(PushStore);
  const modalRef = useRef<HTMLDivElement>();
  const navigate = useNavigate();
  
  const openMeeting = useCallback((meetingId: number, isEditable: boolean) => {
    meetingId && meetingViewModel.loadMeetingById(meetingId, 'inner_meeting').then(() => {
      if (isEditable) {
        meetingPlanerViewModel.setMembers(meetingViewModel.meetingData.members, meetingViewModel.meetingData?.meetingConfirmation);
        meetingPlanerViewModel.setDate(meetingViewModel.meetingData.startDate);
        navigate(PageRoutes.MEETING_PLANNER_PAGE);
      } else navigate(PageRoutes.CALENDAR_PAGE);
    });
    onClose();
  }, []);
  
  useEffect(() => {
    pushStore.connect();
  }, []);

  return (
    visible && <HeaderModal
      onClose={onClose}
      ref={ref}
      alignContent="r-r"
    >
      <div 
        className="push-modal-container"
        ref={modalRef}
      >
        <div className="push-modal-header">Мои уведомления</div>
        <div className="push-notification-container">
          {(pushStore.data.length !== 0)
            ? pushStore.data.map((elem) => (
              <PushNotification 
                ref={modalRef}
                answerMeeting={pushStore.answerMeeting} 
                isPushInactive={pushStore.isPushInactive}
                offerTime={pushStore.offerTime}
                openMeeting={openMeeting} 
                key={elem.id} 
                notification={elem}
              />
            ))
            : <p className="empty-pushs">Уведомлений нет</p>
          }
        </div>
      </div>
    </HeaderModal>
  )
}));